'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../../core/Functions');

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _DomEvents = require('../../utils/DomEvents');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIAbstractSlider = function (_PureComponent) {
  _inherits(UIAbstractSlider, _PureComponent);

  function UIAbstractSlider(props) {
    _classCallCheck(this, UIAbstractSlider);

    var _this = _possibleConstructorReturn(this, (UIAbstractSlider.__proto__ || Object.getPrototypeOf(UIAbstractSlider)).call(this, props));

    _this.state = {
      Dragging: false
    };
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleWindowMouseMove = _this.handleWindowMouseMove.bind(_this);
    _this.handleWindowMouseUp = _this.handleWindowMouseUp.bind(_this);
    _this.refCallback = _this.refCallback.bind(_this);
    return _this;
  }

  _createClass(UIAbstractSlider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindWindowListeners();
    }
  }, {
    key: 'bindWindowListeners',
    value: function bindWindowListeners() {
      window.addEventListener('mousemove', this.handleWindowMouseMove);
      window.addEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: 'unbindWindowListeners',
    value: function unbindWindowListeners() {
      window.removeEventListener('mousemove', this.handleWindowMouseMove);
      window.removeEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(clientX) {
      var onDrag = this.props.onDrag;


      if (this._el == null) return;

      var _el$getBoundingClient = this._el.getBoundingClientRect(),
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right;

      if (left === right) return;

      var DragPercentX = (clientX - left) / (right - left);
      if (DragPercentX < 0) DragPercentX = 0;
      if (DragPercentX > 1) DragPercentX = 1;
      (0, _Functions.callIfPossible)(onDrag, (0, _SyntheticEvent2.default)({ percentX: DragPercentX }));
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(evt) {
      var _props = this.props,
          onMouseDown = _props.onMouseDown,
          onDragStart = _props.onDragStart;

      (0, _Functions.callIfPossible)(onMouseDown, evt);
      if (evt.defaultPrevented) return;

      if ((0, _DomEvents.isLeftClick)(evt)) {
        this.updatePosition(evt.clientX);
        (0, _Functions.callIfPossible)(onDragStart);
        this.bindWindowListeners();
      }
    }
  }, {
    key: 'handleWindowMouseMove',
    value: function handleWindowMouseMove(evt) {
      this.updatePosition(evt.clientX);
    }
  }, {
    key: 'handleWindowMouseUp',
    value: function handleWindowMouseUp() {
      var onDragEnd = this.props.onDragEnd;


      (0, _Functions.callIfPossible)(onDragEnd);
      this.unbindWindowListeners();
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._el = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          __onMouseDown = _props2.onMouseDown,
          __onDragStart = _props2.onDragStart,
          __onDragEnd = _props2.onDragEnd,
          __onDrag = _props2.onDrag,
          rest = _objectWithoutProperties(_props2, ['onMouseDown', 'onDragStart', 'onDragEnd', 'onDrag']);

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        _react2.default.createElement('div', _extends({}, rest, {
          onMouseDown: this.handleMouseDown,
          ref: this.refCallback
        }))
        /* eslint-enable jsx-a11y/no-static-element-interactions */

      );
    }
  }]);

  return UIAbstractSlider;
}(_react.PureComponent);

UIAbstractSlider.displayName = 'UIAbstractSlider';

exports.default = UIAbstractSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/abstract/UIAbstractSlider.js
// module id = 667
// module chunks = 3 4